import React from 'react';
import './roller_loading.css';

interface IProps {
  color?: string;
}

const RollerLoading: React.FC<IProps> = ({color}) => {
  return (
    <div className={`roller-loading color-${color}`}>
      {[0, 1, 2, 3, 4, 5, 6, 7].map(item => {
        return <div key={item} />;
      })}
    </div>
  );
};

export default RollerLoading;



// WEBPACK FOOTER //
// ./src/shared/components/rollerLoading/RollerLoading.tsx